import React from 'react';
import { Card, CardBody, Col, Row, Table, ButtonGroup, Button, Form, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { UsersGroupsAction, UsersGroupsPermissionAction, UIAction } from 'redux/actions';
import { checkPermissions } from 'hooks';
import _ from "lodash";
import { FormGroup } from '@mui/material';

const ManageGroupPermissions = (props) => {

    const isFirstRender = React.useRef(true);
    const [groupPermissions, setGroupPermissions] = React.useState([]);
    const [query, setQuery] = React.useState("");


    React.useEffect(() => {
        let permission = (props.groupPermissions) ? props.groupPermissions : [];
        if (query && query.length > 0) {
            let permissionFilter = permission.filter(item => {
                return (item.name.toUpperCase()).includes(query.toUpperCase())
            });
            setGroupPermissions(permissionFilter)
        } else {
            setGroupPermissions(props.groupPermissions)
        }
    }, [props.groupPermissions])


    const handleChange = (event) => {
        setQuery(event.target.value);
        let permission = (props.groupPermissions) ? props.groupPermissions : [];
        debounce(event.target.value, permission);
    };

    const debounce = React.useCallback(
        _.debounce((searchVal, permission) => {
            console.log(searchVal)
            if (searchVal.length > 0) {
                let permissionFilter = permission.filter(item => {
                    return (item.name.toUpperCase()).includes(searchVal.toUpperCase())
                });
                setGroupPermissions(permissionFilter)
            } else {

                setGroupPermissions(permission)
            }
        }),
        []
    );



    React.useEffect(() => {
        if (isFirstRender.current) {
            let filters = { list: 1 }
            props.getUsersGroups(filters);
            isFirstRender.current = false;
        }
    })

    const handleClick = (permissionId) => {
        props.updateGroupPermission({ group_id: props.selectedGroupId, permission_id: permissionId });
    }

    React.useEffect(() => {
        (props.selectedGroupId) && props.getGroupPermission({ group_id: props.selectedGroupId })
    }, [props.groupPermAdded])

    const handleGroupChange = (event) => {

        if (event.target.value && event.target.value > 0) {
            props.selectGroupId(event.target.value)
            props.getGroupPermission({ group_id: event.target.value })
        } else {
            props.clearPermission();
        }
    }


    const generateRow = (groupPermissions) => {
        return (
            (groupPermissions.length > 0) ?
                groupPermissions.map((item, index) => (
                    <tr key={index}>
                        <td>{item.name}</td>
                        <td>
                            <ButtonGroup>
                                <Button outline={(item.group_permission_count) ? false : true}
                                    color="primary"
                                    onClick={() => handleClick(item.id)}
                                    active={(item.group_permission_count) ? true : false}
                                    disabled={(item.group_permission_count || !checkPermissions(props.loginData, 'group_permissions_update')) ? true : false}
                                >
                                    YES
                                </Button>
                                <Button
                                    outline={(!item.group_permission_count) ? false : true}
                                    color="primary"
                                    onClick={() => handleClick(item.id)}
                                    active={(!item.group_permission_count) ? true : false}
                                    disabled={(!item.group_permission_count || !checkPermissions(props.loginData, 'group_permissions_update')) ? true : false}
                                >
                                    NO
                                </Button>
                            </ButtonGroup>
                        </td>
                    </tr>)
                ) : <tr><td colSpan={"2"} align='center'>Please select group to change permissions</td></tr>
        )
    }


    return (
        <div>

            <Row>
                <Col>

                    <Card className="mb-3">
                        <CardBody>
                            <Form style={{display:'inline-flex'}}>
                                <FormGroup>
                                <Input onChange={handleGroupChange} className="mb-2" type="select" defaultValue={props.selectedGroupId} style={{ width: 200 }}>
                                    <option value={0}>Select Group</option>
                                    {props.groupsArray.map((item) => (<option key={item.id} value={item.id}>{item.name}</option>))}
                                </Input>
                                </FormGroup>
                                <FormGroup>
                                <Input
                                    type="text"
                                    name="query"
                                    id="query"
                                    onChange={handleChange}
                                    autoComplete={'off'}
                                    value={query}
                                    placeholder={'Search Permission'}
                                    style={{ width: 300, marginBottom: 10,marginLeft:10 }}
                                />
                                </FormGroup>
                            </Form>
                            <Table responsive>
                                <thead>
                                    <tr>
                                        <th>Page</th>
                                        <th>Has Permissions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {generateRow(groupPermissions)}
                                </tbody>
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>

    );
}
const mapStateToProps = (state) => ({
    selectedGroupId: (state.uiReducer && state.uiReducer.selectedGroupId) ? state.uiReducer.selectedGroupId : null,
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    groupsArray: (state.groups &&
        state.groups.groupsArray &&
        state.groups.groupsArray.groups) ?
        state.groups.groupsArray.groups : [],
    groupPermissions: (state.groupsPermission &&
        state.groupsPermission.groupPermissions &&
        state.groupsPermission.groupPermissions.data) ?
        state.groupsPermission.groupPermissions.data : [],
    groupPermAdded: (state.groupsPermission &&
        state.groupsPermission.groupPermAdded) ?
        state.groupsPermission.groupPermAdded : null,
    loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});
const mapDispatchToProps = (dispatch) => ({
    selectGroupId: (payload) => dispatch(UIAction.selectGroupId(payload)),
    getUsersGroups: (payload) => dispatch(UsersGroupsAction.getUsersGroups(payload)),
    getGroupPermission: (payload) => dispatch(UsersGroupsPermissionAction.getGroupPermission(payload)),
    updateGroupPermission: (payload) => dispatch(UsersGroupsPermissionAction.updateGroupPermission(payload)),
    clearPermission: () => dispatch(UsersGroupsPermissionAction.getGroupPermissionSuccess([]))
});
export const GroupPermissions = connect(mapStateToProps, mapDispatchToProps)(ManageGroupPermissions);